import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import {coral, grey} from '../primitives/color';

const ButtonStyle = styled.button`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  padding: 8px 16px;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  width: ${props => props.isFullWidth ? '100%' : 'auto'};
`;

export const Button = styled(ButtonStyle)`
  background-color: ${coral.regular};
  color: #fff;

  &:disabled:hover,
  &:disabled {
    background-color: ${coral.lighter};
    cursor: not-allowed;
  }
  
  &:hover:focus,
  &.selected:focus,
  &.selected,
  &:hover {
    background-color: ${coral.light};
  }
  
  &:focus {
    background-color: ${coral.light};
    outline: none;
  }
  
  &:active:focus:hover,
  &.active,
  &:active {
    background-color: ${coral.darker};
  }
  
  ${({lookDisabled}) => lookDisabled ? (css`
    background-color: ${coral.lighter};
    cursor: not-allowed;
    &:hover {
       background-color: ${coral.lighter};
       cursor: not-allowed;
    }
  `) : ''} 
  
  ${({loading}) => loading ? (css`
    pointer-events: none; 
    color: transparent!important;
    
    &:after {
      animation: spinAround .5s infinite linear;
      border: 2px solid #fff;
      border-radius: 290486px;
      border-right-color: transparent;
      border-top-color: transparent;
      content: "";
      display: block;
      height: 1em;
      width: 1em;
      left: calc(50% - (1em / 2));
      top: calc(50% - (1em / 2));
      position: absolute!important; 
    }
  `) : ''} 
`;
Button.displayName = 'Button';
Button.propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    isFullWidth: PropTypes.bool,
    lookDisabled: PropTypes.bool
};

export const SlimButton = styled(Button)`
   padding: 3px 16px;
`;

SlimButton.displayName = 'SlimButton';
SlimButton.propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func
};

export const OutlinedButton = styled(ButtonStyle)`
  border: 1px solid ${grey.grey500};
  background-color: #fff;
  color: #000;
  padding: 9px 16px;

  &:disabled:hover,
  &:disabled {
    border: 1px solid ${grey.grey700};
    background-color: ${grey.grey700};
    color: ${grey.grey400};
    cursor: not-allowed;
  }
  
  &:hover:focus,
  &.selected:focus,
  &.selected,
  &:hover {
    background: ${coral.regular};
    border: 1px solid ${coral.regular};
    color: #fff;
  }
  
  &:focus {
    border: 1px solid ${coral.regular};
    outline: none;
    color: #000;
  }
  
  &:active:focus:hover,
  &:active {
    border: 1px solid ${grey.grey700};
    color: ${grey.grey400};
    background: #fff;
  }
  
  ${({loading}) => loading ? (`
    pointer-events: none; 
    color: transparent!important;
    
    &:after {
      animation: spinAround .5s infinite linear;
      border: 2px solid ${grey.grey400};
      border-radius: 290486px;
      border-right-color: transparent;
      border-top-color: transparent;
      content: "";
      display: block;
      height: 1em;
      width: 1em;
      left: calc(50% - (1em / 2));
      top: calc(50% - (1em / 2));
      position: absolute!important; 
    }
  `) : ''};
  ${({isSelected}) => isSelected ? `
    background: ${coral.regular};
    border: 1px solid ${coral.regular};
    color: #fff !important;
    &:focus,
    &:active {
      color: #fff;
    }    
  ` : ''};
`;

OutlinedButton.displayName = 'OutlinedButton';
OutlinedButton.propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    isFullWidth: PropTypes.bool,
    isSelected: PropTypes.bool
};

export const SlimOutlinedButton = styled(OutlinedButton)`
   padding: 3px 16px;
`;
SlimOutlinedButton.displayName = 'SlimOutlinedButton';
SlimOutlinedButton.propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func
};

export const TabButton = styled(ButtonStyle)`
   border: 1px solid ${grey.grey500};
   outline: none;
   min-width: 90px;
   
   ${({isSelected}) => isSelected ? `
   background: ${coral.lightest};
   border: 1px solid ${coral.regular}; 
   color: ${coral.regular};
   ` : ''};
   
   ${({isFirst}) => isFirst ? `
   border-radius: 2px 0 0 2px;
   ` : ''};
   
   ${({isLast}) => isLast ? `
   border-radius: 0 2px 2px 0;
   ` : ''};
`;

TabButton.displayName = 'TabButton';
TabButton.propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    isSelected: PropTypes.bool,
    isFirst: PropTypes.bool,
    isLast: PropTypes.bool
};
